import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/img/eye-view.svg'
import _imports_2 from '@/assets/img/eye-view-bright.svg'


const _withScopeId = n => (_pushScopeId("data-v-1dd7429e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-account-page overflow-x-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row no-margin" }
const _hoisted_4 = { class: "col-md-12 flex-container" }
const _hoisted_5 = {
  id: "createAccountModal",
  class: "modal fade create-account-modal",
  "data-bs-backdrop": "false",
  "data-bs-keyboard": "false"
}
const _hoisted_6 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = { class: "modal-header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body account-modal" }
const _hoisted_12 = { class: "modal-body-sec1" }
const _hoisted_13 = { class: "account-modal-text" }
const _hoisted_14 = { class: "password-group" }
const _hoisted_15 = {
  for: "id",
  class: "control-label input-label-password"
}
const _hoisted_16 = { class: "password-sec" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = {
  key: 0,
  src: _imports_1
}
const _hoisted_19 = {
  key: 1,
  src: _imports_2
}
const _hoisted_20 = { class: "password-text" }
const _hoisted_21 = { class: "password-text-sec1" }
const _hoisted_22 = { class: "row password-conditions mt-2" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "p-0 password-left-conditions" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "p-0" }
const _hoisted_27 = { class: "create-acc-btn" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "modal-footer" }
const _hoisted_30 = { class: "modal-sec6" }
const _hoisted_31 = { class: "modal-sec6-sec1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerlogo = _resolveComponent("headerlogo")!
  const _component_brandpattern = _resolveComponent("brandpattern")!
  const _component_errorhandler = _resolveComponent("errorhandler")!
  const _component_v_runtime_template = _resolveComponent("v-runtime-template")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "col-md-12",
          style: _normalizeStyle({ 'min-height': _ctx.dyn_height })
        }, [
          _createVNode(_component_headerlogo, {
            "page-type": '1',
            light_logo: true
          }),
          _createElementVNode("div", {
            class: "row no-padding main-body h-100",
            style: _normalizeStyle({ height: _ctx.windowHeight })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_brandpattern, { page: "CREATEACCOUNT" })
            ])
          ], 4)
        ], 4),
        (_ctx.showProspectCallbackError || null)
          ? (_openBlock(), _createBlock(_component_errorhandler, {
              key: 0,
              "prospect-callback-error-msg": _ctx.prospectCallbackErrorMsg,
              onResetShowProspectCallbackError: _ctx.resetShowProspectCallbackError
            }, null, 8, ["prospect-callback-error-msg", "onResetShowProspectCallbackError"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args)))
                }, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getUiText("user-create-heading-1")), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getUiText("user-create-heading-sub-1")), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.getUiText("user-create-create-password-heading-1")), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("input", {
                      id: "psw",
                      ref: "pwd",
                      "data-cy": "psp-create-account-password-input",
                      type: "password",
                      class: "form-control form-control-lg password-input",
                      placeholder: _ctx.passwordPlaceholder,
                      tabindex: "0",
                      onKeyup: [
                        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitPassword && _ctx.submitPassword(...args)), ["enter"])),
                        _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.keyMonitor && _ctx.keyMonitor(...args)))
                      ]
                    }, null, 40, _hoisted_17),
                    _createElementVNode("span", {
                      class: "show-password pr-3",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args)))
                    }, [
                      (!_ctx.enable_showpassword || null)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                        : (_ctx.enable_showpassword || null)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                          : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["show-password-label", _ctx.enable_showpassword ? 'enabled' : 'disabled'])
                      }, _toDisplayString(_ctx.getUiText("user-create-create-password-show-1")), 3)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getUiText("user-create-guidance-heading-1")), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("ul", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUiText(
                            'user-create-guidance-text-1',
                            true,
                          ), (item) => {
                          return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("ul", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUiText(
                            'user-create-guidance-text-2',
                            true,
                          ), (item) => {
                          return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary getstarted-button",
                    "data-cy": "psp-create-account-getstarted-button",
                    disabled: _ctx.disableButton,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitPassword && _ctx.submitPassword(...args)))
                  }, _toDisplayString(_ctx.getUiText("user-create-button-create-account-1")), 9, _hoisted_28)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_v_runtime_template, { template: _ctx.footerText }, null, 8, ["template"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}